// extracted by mini-css-extract-plugin
module.exports = {"container":"iVaxSgtmMkNilCIK_RsD"};